import { LoadingSpinner } from '@/components/ui/LoadingSpinner';

const LoadingPage = () => {
  return (
    <LoadingSpinner
      containerClassName="h-screen"
      size="lg"
      label="Carregando..."
      description="Por favor, aguarde enquanto carregamos o conteúdo."
    />
  );
};

export default LoadingPage;
